<app-header></app-header>
<div class="content small-head">
  <mat-card appearance="outlined" class="info-card">

    <div class="select-training-text">
      <h3>{{'KbCommonTitle' | translate }}</h3>
    </div>
    <ng-template #kfrLogo>
      <div class="kfr-logo">
        <!-- <img class="logo" src="../../../assets/logo-circle.png" alt="Swiss Krono"> -->
      </div>
    </ng-template>
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="lang-btns" value="pl">

      @for (lng of langs; track lng) {
        <mat-button-toggle mat-icon-button color="primary" aria-label="{{lng.desc}}" value="{{lng.name}}" (click)="setLang(lng.code)">
          <div class="flag-wrapper">
            <div class="flag flag-icon-background flag-icon-{{lng.name}}"></div>
          </div>
          <span>{{lng.desc}}</span>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    <mat-divider></mat-divider>
    <div class="select-training-text">
      <h3>{{'BookTypeSelect' | translate }}</h3>
    </div>
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="train-btns" value="{{selectedExam}}">
      <!-- <ng-container *ngFor="let train of trainings; let indx = index">
      <mat-button-toggle mat-icon-button aria-label="" value="{{train.trainingTypeId}}" (change)="selectionChanged($event.value)">
        <span>{{train.description}}</span>
      </mat-button-toggle>
    </ng-container> -->
    <mat-button-toggle class="kb-btn" mat-icon-button aria-label="" value="kbw" (change)="selectionChanged($event.value)">
      <span>{{'KbwAndKbk' | translate}}</span>
      <i class="material-icons">group</i>
    </mat-button-toggle>
    <mat-button-toggle class="kb-btn" mat-icon-button aria-label="" value="kbk" (change)="selectionChanged($event.value)">
      <span>{{'KbTitle' | translate}}</span>
      <i class="material-icons">directions_car</i>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <mat-divider></mat-divider>
  <!-- <button mat-raised-button color="primary" class="next-btn" (click)=onClick()>{{'NextBtn' | translate}}</button> -->
</mat-card>
</div>

